import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatUrl } from '@ifeng/public_method';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '@Container/common/client/utils/rel';

class ObNewsItem extends React.PureComponent {
    static propTypes = {
        pitObservation: PropTypes.array,
    };

    static defaultProps = {
        pitObservation: [],
    };

    render() {
        const { pitObservation } = this.props;

        return (
            <div className={styles.newsItem}>
                <h1>
                    <a href={formatUrl(pitObservation[0].url)} target="_blank" title="" rel={rel}>
                        {pitObservation[0].title}
                    </a>
                </h1>
                <div className={styles.zz}>
                    <span>
                        作者：<b>{pitObservation[0].author ? pitObservation[0].author : ''}</b>
                    </span>
                    <span>
                        时间：<b>{pitObservation[0].newsTime}</b>
                    </span>
                    <p>{pitObservation[0].summary}</p>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ObNewsItem);
